// Function loadshopProductBlock loads the shopProductBlock class by dynamically importing the js on demand if needed

export function loadShopProductBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-product-block-chunk" */ '../widgets/shopProductBlock').then(wg => {

		const { ShopProductBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopProductBlock"]');

		if(!$wg) {
			// console.info('ShopProductBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopProductBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopProductBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopProductBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopProductBlock widget');

}
